module.exports = __webpack_public_path__ + "img/agent-registration-illustration.fce30ea6.png";